import { isJSON } from './jsonHelper';
export const request = ({ method = 'post', url, data, success, fail }) => {
    if (!isJSON(data)) {
        return;
    }
    const xhr = new XMLHttpRequest();
    xhr.addEventListener('readystatechange', () => {
        if (xhr.readyState === 4) {
            if (xhr.status >= 400 || xhr.status === 0) {
                fail === null || fail === void 0 ? void 0 : fail(xhr.response);
            }
            else {
                success === null || success === void 0 ? void 0 : success(xhr.response);
            }
        }
    });
    xhr.open(method, url);
    xhr.setRequestHeader('Content-Type', 'application/json');
    xhr.send(data);
};
